<template>
  <div class="models-grid">
    <slot></slot>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss">
.models-grid {
  max-width: 60rem;
}
</style>
